import { BigSearchIcon } from '@/component/Icons/BigSearchIcon';
import { useListingSearchStore } from '@/store';
import { pushSearchButton } from '@/utils/gtm';
import { useTranslations } from 'next-intl';

import { useSearchSubmit } from '../../hooks';

import styles from './Button.module.css';

export const SearchListingButton = ({ theme, pageName }) => {
  const { focusField } = useListingSearchStore();
  const t = useTranslations();
  const { onSearch: onButtonClick, redirecting } = useSearchSubmit();

  return (
    <div
      className={`search-button-box flex items-center rounded-r-[20px] ${
        focusField === 'guests' ? '!bg-white' : ''
      } ${theme === 'compact' ? 'p-1' : 'p-2.5'}
      ${theme === 'vertical' ? 'py-2.5 pr-2.5 pl-0' : ''}`}
      onClick={() => pushSearchButton(pageName)}
    >
      <button
        className={`${styles.button}${redirecting ? ' opacity-50' : ''} ${
          theme === 'vertical' ? '!h-11 !w-auto pr-4 pl-6' : ''
        }`}
        aria-label="search listing button"
        onClick={onButtonClick}
        disabled={redirecting}
        tabIndex={1}
      >
        <span
          className={`label-search capitalize lg:hidden ${
            theme === 'vertical' ? 'lg:!inline-flex' : ''
          }`}
        >
          {t('search')}
        </span>
        <BigSearchIcon
          color="white"
          size={`26 ${theme === 'vertical' ? '24' : ''}`}
        />
      </button>
    </div>
  );
};

export const SearchListingButtonIcon = () => {
  const { focusField } = useListingSearchStore();
  const { onSearch: onButtonClick, redirecting } = useSearchSubmit();

  return (
    <div
      className={`flex items-center rounded-r-[20px] ${
        focusField === 'guests' ? '!bg-white' : ''
      }`}
      onClick={() => pushSearchButton(pageName)}
    >
      <button
        className={`btn btn-primary btn-sm btn-icon ${
          redirecting ? ' opacity-50' : ''
        }`}
        aria-label="search listing button"
        onClick={onButtonClick}
        disabled={redirecting}
        tabIndex={1}
      >
        <BigSearchIcon color="white" size="26" />
      </button>
    </div>
  );
};
